"use client";

import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import { SupportForm } from "./SupportForm";
import { CheckCircle2, Clock, MessageSquare } from "lucide-react";

const STEPS = [
  { Icon: CheckCircle2, title: "1 · Confirmation", description: "You'll receive a confirmation email with your ticket ID." },
  { Icon: Clock, title: "2 · Review", description: "Our team reviews your request within 24–48 hours." },
  { Icon: MessageSquare, title: "3 · Resolution", description: "We'll keep you updated on progress and resolution." },
];

const SLA = [
  { priority: "Urgent", dot: "#E24B4A", response: "Within 4 hours", resolution: "Within 24 hours" },
  { priority: "Critical", dot: "#EF9F27", response: "Within 8 hours", resolution: "Within 48 hours" },
  { priority: "Major", dot: "#E3B45E", response: "Within 24 hours", resolution: "Within 3–5 days" },
  { priority: "Minor & trivial", dot: "#26E0E6", response: "Within 48 hours", resolution: "Within 1 week" },
];

export default function SupportPage() {
  return (
    <div className="kuttos-site">
      <SiteNav />

      {/* Hero */}
      <section style={{ position: "relative", overflow: "hidden" }}>
        <div className="st-hero-glow" />
        <div className="st-hero-grid" />
        <div className="st-section" style={{ position: "relative", paddingTop: 64, paddingBottom: 28, textAlign: "center" }}>
          <div className="st-eyebrow" style={{ marginBottom: 16 }}>// Support</div>
          <h1 className="st-disp" style={{ fontSize: "clamp(30px,5vw,44px)", lineHeight: 1.06, fontWeight: 700, color: "#fff", margin: "0 auto 14px", maxWidth: 560 }}>
            We're here to help
          </h1>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: "var(--st-muted)", maxWidth: 480, margin: "0 auto" }}>
            Submit a bug report, feature request or question and our team will get back to you.
          </p>
        </div>
      </section>

      {/* Form */}
      <section className="st-section" style={{ paddingTop: 8, paddingBottom: 8, maxWidth: 760 }}>
        <div className="st-card" style={{ padding: "28px 24px" }}>
          <div style={{ textAlign: "center", marginBottom: 22 }}>
            <h2 className="st-disp" style={{ fontSize: 22, fontWeight: 700, color: "#fff", margin: "0 0 6px" }}>Submit a request</h2>
            <p style={{ fontSize: 13.5, color: "var(--st-muted)", margin: 0 }}>Fill out the form below and we'll get back to you as soon as possible.</p>
          </div>
          <SupportForm />
        </div>
      </section>

      {/* What happens next */}
      <section className="st-section" style={{ paddingTop: 44 }}>
        <h2 className="st-disp" style={{ fontSize: "clamp(20px,4vw,24px)", fontWeight: 700, color: "#fff", textAlign: "center", margin: "0 0 22px" }}>What happens next</h2>
        <div className="st-grid-3">
          {STEPS.map(({ Icon, title, description }) => (
            <div key={title} className="st-card" style={{ padding: 20 }}>
              <div className="st-ic" style={{ marginBottom: 12 }}><Icon size={19} /></div>
              <div className="st-disp" style={{ fontSize: 14.5, fontWeight: 700, color: "#fff", marginBottom: 6 }}>{title}</div>
              <div style={{ fontSize: 13, color: "var(--st-muted)", lineHeight: 1.55 }}>{description}</div>
            </div>
          ))}
        </div>
      </section>

      {/* SLA */}
      <section className="st-section" style={{ paddingTop: 44, paddingBottom: 56 }}>
        <h2 className="st-disp" style={{ fontSize: "clamp(20px,4vw,24px)", fontWeight: 700, color: "#fff", textAlign: "center", margin: "0 0 22px" }}>Response times</h2>
        <div className="st-grid-2">
          {SLA.map((s) => (
            <div key={s.priority} className="st-card" style={{ padding: 18 }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                <span style={{ width: 9, height: 9, borderRadius: 999, background: s.dot, marginRight: 9 }} />
                <span style={{ fontSize: 14.5, fontWeight: 600, color: "#fff" }}>{s.priority}</span>
              </div>
              <p style={{ fontSize: 13, color: "var(--st-muted)", margin: 0, lineHeight: 1.6 }}>
                <strong style={{ color: "#fff", fontWeight: 600 }}>Response:</strong> {s.response}
                <br />
                <strong style={{ color: "#fff", fontWeight: 600 }}>Resolution:</strong> {s.resolution}
              </p>
            </div>
          ))}
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
